<template>
    <div id="appRoot" :class="scrollable">
        <div id="root" :class="scrollable">
            <div id="grid-root">
                <ToolBar class="toolbar"/>

                <transition name="fade">
                    <router-view v-scroll="onScroll" :key="$route.fullPath"/>
                </transition>

                <button @click="scrollToTop" :class="showFab"
                        class="mdc-fab mdc-fab scrollTop ">
                    <div class="mdc-fab__ripple"></div>
                    <img class="arrow mdc-fab__icon" src="./assets/chevron-down.svg"/>
                </button>
                <Footer v-on:emailSent="scrollToTop" :showContact="this.$route.name === 'about'"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ToolBar from "./components/ToolBar.vue";
    import Footer from "./components/Footer.vue";

    export default {
        name: "app",
        components: {
            ToolBar,
            Footer
        },
        props: {
            initialOffset: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                offsetTop: this.initialOffset
            };
        },
        methods: {
            onScroll() {
                this.offsetTop = window.pageYOffset
                this.$store.commit('onAppScroll', this.offsetTop)
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            scrollBy(y) {
                window.scrollTo({
                    top: this.offsetTop + y,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },
        computed: {
            scrollable: function () {
                let isModalOpen = this.$store.state.modalViewOpen
                if (isModalOpen === true)
                    document.body.style['overflow-y'] = 'hidden'
                else
                    document.body.style['overflow-y'] = 'auto'
                return {
                    fixed: isModalOpen
                };
            },
            showFab: function () {
                return {
                    'mdc-fab--exited': this.offsetTop < 200
                }
            },
        }
    };
</script>

<style lang="scss" src="./styles/app.scss"/>
